'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudUpload = function IoIosCloudUpload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.9 35v-7.5h1.2v7.5h-1.2z m11.8-20.6c3.5 0 6.3 3 6.3 6.6s-2.9 6.5-6.4 6.5h-10.5v-11.4l4.3 4.2 1-0.8-5.9-5.9-5.8 5.9 0.9 0.8 4.3-4.2v11.4h-9.9c-3.9 0-7-3.1-7-7 0-3.2 2-5.8 4.8-6.7 0.4-2.2 2.2-4.1 4.6-4.1 0.8 0 1.4 0.1 2 0.5 1.5-3.1 4.6-5.2 8.2-5.2 5 0 9.2 4.1 9.2 9.1 0 0-0.1 0.2-0.1 0.3z' })
        )
    );
};

exports.default = IoIosCloudUpload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloud-upload.js
// module id = 2123
// module chunks = 0